import React from 'react'
import './_badgePlaceholder.scss'

interface BadgePlaceholderProps {
  position: number // 1-6 position for the featured badge slot
  size?: number // Size in px, defaults to 32
  isActive?: boolean // Highlight when drag target is over
  isSelected?: boolean // Highlight when this slot is selected for badge assignment
  onClick?: () => void // Handler for click to enter selection mode
  onDragOver?: (e: React.DragEvent) => void // Handler when drag enters
  onDragLeave?: (e: React.DragEvent) => void // Handler when drag leaves
  onDrop?: (e: React.DragEvent) => void // Handler for drop event
}

// Placeholder component for empty featured badge slots.
// Displays a circular target area with corner brackets and a plus icon.
// Supports drag-and-drop from badge items and click-to-select mode.
const BadgePlaceholder: React.FC<BadgePlaceholderProps> = ({
  position,
  size,
  isActive = false,
  isSelected = false,
  onClick,
  onDragOver,
  onDragLeave,
  onDrop,
}) => {
  // Build class list based on state.
  const classNames = [
    'badge-placeholder',
    isActive && 'badge-placeholder--active',
    isSelected && 'badge-placeholder--selected',
  ].filter(Boolean).join(' ')

  return (
    <div
      className={classNames}
      style={size ? { '--placeholder-size': `${size}px` } as React.CSSProperties : undefined}
      data-position={position}
      data-droppable="true"
      onClick={onClick}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {/* Corner bracket elements */}
      <span className="badge-placeholder__corner badge-placeholder__corner--top-left" />
      <span className="badge-placeholder__corner badge-placeholder__corner--top-right" />
      <span className="badge-placeholder__corner badge-placeholder__corner--bottom-left" />
      <span className="badge-placeholder__corner badge-placeholder__corner--bottom-right" />

      {/* Plus icon in the center */}
      <span className="badge-placeholder__plus" />
    </div>
  )
}

export default BadgePlaceholder
